import Vue from 'vue'
import App from './App.vue'
//import router from './router'
import router from './route/index'
import store from './store/index'
import ElementUI from 'element-ui';
import echarts from 'echarts'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/global.css'
import axios from './http'
import './assets/css/icon.css'
import CommonUtil from './common';

Vue.use(ElementUI);
Vue.use(CommonUtil);
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$echarts = echarts;
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');


function onInput(el, ele, binding, vnode) {
  function handle() {
    let val = ele.value
    // modifiers为修饰符对象，传入了float，则其float属性为true
    if (binding.modifiers.float) {
    // 清除"数字"和"."以外的字符
    val = val.replace(/[^\d.]/g, '')
    // 只保留第一个, 清除多余的
    val = val.replace(/\.{2,}/g, '.')
    // 第一个字符如果是.号，则补充前缀0
    val = val.replace(/^\./g, '0.')
    } else {
      val = ele.value.replace(/[^\d]/g, '')
    }
    ele.value = val
  }

  return handle
}
const numberInput= {
  bind(el, binding, vnode) {
    const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
    ele.addEventListener('input', onInput(el, ele, binding, vnode), false)
  },
}
Vue.directive('number-input', numberInput)

